import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './CarOverview.css';

const CarOverview = () => {
  const { language } = useLanguage();
  
  // 所有汽车图片文件列表
  const carImages = [
    { filename: 'OIP-C (1).webp', name: 'Toyota Roomy' },
    { filename: 'OIP-C.webp', name: 'Mitsubishi ek-X-space' },
    { filename: 'Weixin Image_20251222234713_27_432.jpg', name: 'Nissan Serena' },
    { filename: 'Weixin Image_20251222234714_29_432.jpg', name: 'Honda N Box' },
    { filename: 'Weixin Image_20251222234715_31_432.jpg', name: 'Honda FIT' },
    { filename: 'Weixin Image_20251222234716_32_432.jpg', name: 'Suzuki Solio' },
    { filename: 'Weixin Image_20251222234716_33_432.jpg', name: 'Toyota Pixis' },
    { filename: 'Weixin Image_20251222234717_34_432.jpg', name: 'Tanto' },
    { filename: 'Weixin Image_20251222234717_35_432.jpg', name: 'Toyota Aqua' },
    { filename: 'Weixin Image_20251222234718_36_432.jpg', name: 'Mazda Biante' },
    { filename: 'Weixin Image_20251222234749_37_432.jpg', name: 'Suzuki Lapin' },
    { filename: 'Weixin Image_20251222234750_38_432.jpg', name: 'Toyota Woxy' },
    { filename: 'Weixin Image_20251222234750_39_432.png', name: 'Toyota Alphard' },
    { filename: 'Weixin Image_20251222234751_40_432.jpg', name: 'Toyota Alphard2' },
    { filename: 'Weixin Image_20251222234752_41_432.jpg', name: 'Toyota Vellfire' },
    { filename: 'Weixin Image_20251222234753_42_432.jpg', name: 'Toyota Alphard' },
    { filename: 'Weixin Image_20251222234754_43_432.jpg', name: 'Honda FIT' },
    { filename: 'Weixin Image_20251222234912_45_432.jpg', name: 'Toyota Alphard4' },
  ];

  return (
    <div className="car-overview">
      <div className="home-title">
        {language === 'ja' ? '豊富な車種 - 全車展示' : 'Wide Selection of Vehicles  '}
      </div>
      <div className="car-grid">
        {carImages.map((car, index) => (
          <div key={index} className="car-card">
            <div className="car-image">
              <img 
                src={`/images/${car.filename}`} 
                alt={car.name}
                onError={(e) => {
                  e.target.src = '/images/placeholder.png';
                }}
              />
            </div>
            <div className="car-name">{car.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarOverview;
